module.exports = __webpack_public_path__ + "4780396f0cdb96a6b99128770650bbd8.jpg";


//////////////////
// WEBPACK FOOTER
// ./photo.jpg
// module id = 491
// module chunks = 0